import Dodoable from 'models/dodoable'
import getModelCollection from 'braindamage/api/getModelCollection'
import { useQuery } from '@tanstack/react-query'

export default ({ query, path = "/api/dodoables" } = {}) => {
  return useQuery({
    queryKey: ['dodoables', path, query],
    queryFn: async () => {
      const data = await getModelCollection(path, Dodoable, query)
      return data
    },
    onError: async (data) => {
      console.log("useDodoableCollectionQuery Error:", data)
    }
  })
}
